export default "__VITE_PUBLIC_ASSET__5c4d9372__"